import * as React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

const rawData = [
  { id: "Borrowdale", value: 40, label: "Borrowdale" },
  { id: "Highlands", value: 20, label: "Highlands" },
  { id: "Langhorn Lane", value: 10, label: "Langhorn Lane" },
  { id: "Mount Pleasant", value: 8, label: "Mount Pleasant" },
  { id: "Unknown", value: 7, label: "Unknown" },
  { id: "CBD", value: 5, label: "CBD" },
  { id: "Harare", value: 10, label: "Harare" },
];

const LIGHT_BLUE = "#6fabddcc";
const data = rawData.map((d) => ({ ...d, color: LIGHT_BLUE }));

/* ---------------- Center Label ---------------- */
const StyledText = styled("text")(({ theme }: { theme: Theme }) => ({
  fill: "#ffffff",
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 18,
  fontWeight: 600,
}));

function PieCenterLabel({ children }: { children: React.ReactNode }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

/* ---------------- Center Circle ---------------- */
function PieCenterCircle({ radius }: { radius: number }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <circle
      cx={left + width / 2}
      cy={top + height / 2}
      r={radius}
      fill="#4a96e2ff" // dark blue center
    />
  );
}

/* ---------------- Widget ---------------- */
const CHART_SIZE = 420; // fixed chart size

const CitySuburbWidget = () => {
  return (
    <Card
      sx={{
        height: "100%", // Card fills its container vertically
        width: "100%", // Card fills its container horizontally
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Typography variant="h6" textAlign="center" sx={{ mb: 1 }}>
          City–Suburb Hierarchy
        </Typography>

        <Box
          sx={{
            width: CHART_SIZE,
            height: CHART_SIZE,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PieChart
            width={CHART_SIZE}
            height={CHART_SIZE}
            series={[
              {
                data,
                innerRadius: CHART_SIZE * 0.17,
                outerRadius: CHART_SIZE * 0.46,
                paddingAngle: 0.5,
                arcLabel: (item) => `${item.label}`,
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fontSize: 11,
                fill: "#ffffff",
              },
            }}
            hideLegend
          >
            <PieCenterCircle radius={CHART_SIZE * 0.19} />
            <PieCenterLabel>Harare</PieCenterLabel>
          </PieChart>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CitySuburbWidget;
